// extracted by mini-css-extract-plugin
module.exports = {"image":"yH-z","loaded":"zH-z","placeholder":"AH-z"};